// 全局混入公共方法：任意组件内可直接 this.xxx() 调用
export default {
  methods: {
    // 新接口(listTDeviceInfo)返回值转换为旧接口设备列表结构
    Fnreturndev(res) {
      let items = (res && res.data && res.data.items) || [];
      return items.map(item => {
        // 实时采集数据(仅下方未使用的outpower/energyToday/energyTotal/soc取值此，若删除未使用字段可一并移除)
        let dcs = item.dcsCollectDataDTO || {};
        return {
          // 设备名称 -> 设备别名
          devalias: item.deviceName,
          // sn用于接口调用，deviceSn用于展示(deviceSn不存在则用sn兜底)
          sn: item.sn,
          deviceSn: item.deviceSn || item.sn,
          // 状态使用deviceStatus，逻辑不变
          status: item.deviceStatus,
          brand: item.brand,
          // 设备型号
          devtype: item.deviceModel,
          // 数采器别名(新接口顶层直接返回collalias)
          collalias: item.collalias,
          pn: item.pn,
          devaddr: item.devaddr,
          devcode: item.devcode,
          // 设备属主账号/ID
          usr: item.deviceUserName,
          uid: item.deviceUserId,
          // 收益字段(新接口顶层直接返回)
          profitToday: item.profitToday,
          profitTotal: item.profitTotal,
          buyProfitToday: item.buyProfitToday,
          buyProfitTotal: item.buyProfitTotal,
          sellProfitToday: item.sellProfitToday,
          sellProfitTotal: item.sellProfitTotal,
          pid: item.pid,
          // 关注状态(新接口顶层直接返回focus)
          focus: item.focus,
          // 以下 outpower~electrafyStatus 共11个字段全项目无任何页面消费(2026-09排查)，仅为保留旧结构，可整体删除
          // 当前功率 - 全项目未使用
          outpower: dcs.outpower,
          // 日发电量 - 全项目未使用
          energyToday: dcs.energyToday,
          // 年发电量 - 全项目未使用
          energyYear: undefined,
          // 总发电量 - 全项目未使用(项目页同名列来自webQueryPlants，与设备无关)
          energyTotal: dcs.energyTotal,
          // 日/总买电量 - 全项目未使用
          buyEnergyToday: undefined,
          buyEnergyTotal: undefined,
          // 日/总卖电量 - 全项目未使用
          sellEnergyToday: undefined,
          sellEnergyTotal: undefined,
          // 电池soc - 全项目未使用(能流图soc来自能流接口)
          soc: dcs.soc,
          // wifi状态 - 全项目未使用
          wifiStatus: undefined,
          // 美卓特殊状态字段 - 全项目未使用
          electrafyStatus: undefined,
          // 日月元自适应升级标识(新接口顶层直接返回otaLabel，升级页LFU按钮有消费)
          otaLabel: item.otaLabel,
          // 固件版本(旧字段fireware)
          fireware: item.firmwareVersion,
        };
      });
    },
  },
};
